'use client';

import * as React from 'react';
import { useEnhancedEffect } from './useEnhancedEffect.js';
export function useLatestRef(value) {
  const ref = React.useRef(value);
  useEnhancedEffect(() => {
    ref.current = value;
  });
  return ref;
}